var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapsible",class:{
    'collapsible--no-color': _vm.noColor,
    'collapsible--no-margin': _vm.noMargin,
    'collapsible--border': _vm.bordered,
  }},[_c('div',{class:{
      collapsible__trigger: true,
      'collapsible__trigger--open': !_vm.transitioning && _vm.open,
      'collapsible__trigger--closed': !_vm.transitioning && !_vm.open,
      'collapsible__trigger--transitioning': _vm.transitioning,
    },on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('div',{staticClass:"collapsible__title"},[(_vm.icon)?_c('Icon',{staticClass:"collapsible__title__icon"},[_vm._v(_vm._s(_vm.Icons[_vm.icon]))]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.title))])],1),_c('div',{staticClass:"collapsible__arrow__wrapper"},[_c('Icon',{staticClass:"collapsible__arrow",class:{
          collapsible__trigger: true,
          'collapsible__arrow--open': _vm.open,
          'collapsible__arrow--closed': !_vm.open,
        }},[_vm._v(" "+_vm._s(_vm.Icons['arrowDownThin'])+" ")])],1)]),_c('div',{class:{
      collapsible__content: true,
      'collapsible__content--open': !_vm.transitioning && _vm.open,
      'collapsible__content--closed': !_vm.transitioning && !_vm.open,
      'collapsible__content--transitioning': _vm.transitioning,
    },style:({
      height: _vm.height,
      transitionProperty: 'height',
      transitionDuration: _vm.transitionDuration,
      transitionTimingFunction: _vm.transitionTimingFunction,
      transitionDelay: _vm.transitionDelay,
    }),on:{"transitionend":_vm.handleEnd}},[_c('div',{ref:"inner",staticClass:"collapsible__contentInner"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }